import BaseStore from "./Base.store";

export default class AgendamentoTipoStore extends BaseStore {

}
